import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

export default class Row extends Component {
  render() {
    const { className, children, ...rest } = this.props;
    const classes = ['rec-nested-wrap', className].filter((v) => !!v).join(' ');

    return (
      <div className={classes} {...rest}>
        {children}
      </div>
    );
  }
}

Row.propTypes = propTypes;
